"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Modal = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importStar(require("react"));
var browser_utils_1 = require("@walletconnect/browser-utils");
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
var qrcode_react_1 = __importDefault(require("qrcode.react"));
var Modal = function (_a) {
    var uri = _a.uri, close = _a.close;
    var checkMobile = (0, react_1.useState)(function () { return (0, browser_utils_1.isMobile)(); })[0];
    var checkAndroid = (0, react_1.useState)(function () { return (0, browser_utils_1.isAndroid)(); })[0];
    var navigateToAppURL = (0, react_1.useMemo)(function () {
        if (checkMobile) {
            if (checkAndroid) {
                (0, browser_utils_1.saveMobileLinkInfo)({
                    name: "Cosmostation",
                    href: "intent://wc#Intent;package=wannabit.io.cosmostaion;scheme=cosmostation;end;",
                });
                return "intent://wc?".concat(uri, "#Intent;package=wannabit.io.cosmostaion;scheme=cosmostation;end;");
            }
            else {
                (0, browser_utils_1.saveMobileLinkInfo)({
                    name: "Cosmostation",
                    href: "cosmostation://wc",
                });
                return "cosmostation://wc?".concat(uri);
            }
        }
    }, [checkAndroid, checkMobile, uri]);
    (0, react_1.useEffect)(function () {
        if (navigateToAppURL) {
            window.location.href = navigateToAppURL;
        }
    }, [navigateToAppURL]);
    return ((0, jsx_runtime_1.jsx)(react_1.default.Fragment, { children: (0, jsx_runtime_1.jsx)("div", __assign({ style: {
                position: "fixed",
                top: 0,
                bottom: 0,
                left: 0,
                right: 0,
                backgroundColor: "rgba(0,0,0,0.1)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
            }, onClick: function (e) {
                e.preventDefault();
                e.stopPropagation();
                close();
            } }, { children: (0, jsx_runtime_1.jsx)("div", __assign({ style: {
                    padding: 20,
                    borderRadius: 10,
                    backgroundColor: "#DDDDDD",
                }, onClick: function (e) {
                    e.preventDefault();
                    e.stopPropagation();
                } }, { children: !checkMobile ? ((0, jsx_runtime_1.jsxs)(react_1.default.Fragment, { children: [(0, jsx_runtime_1.jsx)("h3", __assign({ style: {
                                fontSize: 20,
                                margin: 0,
                                marginBottom: 10,
                            } }, { children: "Scan QR Code" })), (0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)(qrcode_react_1.default, { size: 250, value: uri }) })] })) : ((0, jsx_runtime_1.jsxs)(react_1.default.Fragment, { children: [(0, jsx_runtime_1.jsx)("h3", __assign({ style: {
                                fontSize: 20,
                                margin: 0,
                                marginBottom: 10,
                            } }, { children: "Open App" })), (0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)("button", __assign({ onClick: function () {
                                    if (navigateToAppURL) {
                                        window.location.href = navigateToAppURL;
                                    }
                                } }, { children: "Cosmostation" })) })] })) })) })) }));
};
exports.Modal = Modal;
